var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"layout"},[_c('div',{staticClass:"topBar"},[_c('TopBar',{on:{"changeNavStatus":_vm.changeNavStatus,"clickBill":_vm.clickBill,"clickLogo":_vm.clickLogo}})],1),_c('div',{staticClass:"sideBar"},[_c('SideBar',{ref:"sideBar"})],1),_c('levitated'),_c('router-view',{staticClass:"wrap"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }